import type { MessageDescriptor } from "@lingui/core";
import { msg } from "@lingui/core/macro";
import type { ComponentType } from "react";
import {
  ActivityIcon,
  ArchiveIcon,
  ChartColumnIcon,
  KeyboardIcon,
  Link2Icon,
  Settings2Icon,
  ToggleRightIcon,
} from "lucide-react";

export type SettingsSectionPath =
  | "/settings/general"
  | "/settings/keybindings"
  | "/settings/connections"
  | "/settings/usage"
  | "/settings/capabilities"
  | "/settings/diagnostics"
  | "/settings/archived";

export interface SettingsNavItem {
  readonly label: MessageDescriptor;
  readonly to: SettingsSectionPath;
  readonly icon: ComponentType<{ className?: string }>;
  readonly access?: "read" | "write";
}

const SETTINGS_NAV_ITEMS: ReadonlyArray<SettingsNavItem> = [
  { label: msg`General`, to: "/settings/general", icon: Settings2Icon },
  { label: msg`Keybindings`, to: "/settings/keybindings", icon: KeyboardIcon },
  { label: msg`Connections`, to: "/settings/connections", icon: Link2Icon },
  { label: msg`Usage`, to: "/settings/usage", icon: ChartColumnIcon, access: "read" },
  {
    label: msg`Capabilities`,
    to: "/settings/capabilities",
    icon: ToggleRightIcon,
    access: "write",
  },
  {
    label: msg`Diagnostics`,
    to: "/settings/diagnostics",
    icon: ActivityIcon,
    access: "write",
  },
  { label: msg`Archive`, to: "/settings/archived", icon: ArchiveIcon },
];

export function visibleSettingsNavItems(access: {
  readonly hasAccess: boolean;
  readonly canWrite: boolean;
}): ReadonlyArray<SettingsNavItem> {
  return SETTINGS_NAV_ITEMS.filter((item) =>
    item.access === undefined ? true : item.access === "read" ? access.hasAccess : access.canWrite,
  );
}
